import {InjectionToken} from "@angular/core";

export abstract class Parent {

}

export const ParentRef = new InjectionToken<Parent>('ParentComponent');
